import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import './App.css';
import Body from './components/body/Body';
import Footer from './components/footer/Footer';
import ModelViewerAPIConsumer from './components/modelController/ModelViewerAPIConsumer';
import ZoomToMaterial from './components/modelController/ZoomToMaterial';
import data from './data/carouselItems.json'
import Div100vh from 'react-div-100vh'
const allDummyState = {
  kiltWaist: '',
  kiltHips: '',
  kiltLength: '',
  kiltTartan: '',
  strap: '',
  buckle: '',
  lining: '',
  pleatToTheStripe: false
}

// const noDummyState = {
//   kiltWaist: '',
//   kiltHips: '',
//   kiltLength: '',
//   kiltTartan: '',
//   strap: '',
//   kiltBuckles: '',
//   kiltLining: ''
// }

function App () {

  const [currentStepIndex, setCurrentStepIndex] = useState(0)
  const [modelLoaded, setModelLoaded] = useState(false)
  const [listData, setListData] = useState(data)
  const [formState, setFormState] = useState({ ...allDummyState })
  const [basketState, setBasketState] = useState({})
  const { pleatToTheStripe, kiltTartan } = formState

  useEffect(() => {
    // get the kilt stuff and update
    data[0].forms.controls[1].optionCategories[0].options.forEach((option) => {
      option.materialListId = pleatToTheStripe ? option.materialListId.replaceAll('_stripe', '') + '_stripe' : option.materialListId.replaceAll('_stripe', '')
      option.forceClick = (option.optionValue === kiltTartan ? true : false)
    })
    _setListData(data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pleatToTheStripe, kiltTartan])


  const _setFormState = (newFormState) => {
    setFormState({ ...newFormState })
  }

  const _setBasketState = (newBasketState) => {
    setBasketState({ ...newBasketState })
  }

  const _setListData = (listData) => {
    return setListData([...listData])
  }

  const _setCurrentStepIndex = (idx) => {
    for (let i = 0; i < idx; i++) {
      validateOptionForm(i)
    }
    if (idx >= 0 && idx < data.length) {
      setCurrentStepIndex(idx)
    }

  }

  const validateOptionForm = (i) => {
    const form = document.querySelector(`#optionsForm_${i} `)
    if (form) {
      const isValid = form.checkValidity()
      listData[i].wasValidated = true
      listData[i].isValid = isValid
      // if (!isValid && scrollOnError) {
      //   document.querySelector('#modalTop').scrollIntoView({ behaviour: 'smooth' })
      // }
      form.classList.add('shake1')
      _setListData(listData)
    }
  }

  const validateCurrentOptionForm = (scrollOnError) => {
    const form = document.querySelector(`#optionsForm_${currentStepIndex} `)
    if (form) {
      const isValid = form.checkValidity()
      listData[currentStepIndex].wasValidated = true
      listData[currentStepIndex].isValid = isValid
      if (!isValid && scrollOnError) {
        document.querySelector('#modalTop').scrollIntoView({ behaviour: 'smooth' })
      }
      form.classList.add('shake1')
      _setListData(listData)
    }
  }

  return (
    <>
      <ModelViewerAPIConsumer
        listData={listData}
        setCurrentStepIndex={setCurrentStepIndex}
        setModelLoaded={setModelLoaded}
      />
      <ZoomToMaterial
        listData={listData}
        currentStepIndex={currentStepIndex}
        modelId='-NEkf_eg41R8np4ASsS3'
        viewerId='modelFrame'
      />
      <Div100vh >
        <Container className={`d-flex h-100 flex-column p-3 p-lg-0 ${modelLoaded ? 'pe-auto opacity-100' : 'pe-none opacity-75'} `}>

          <Body
            basketState={basketState}
            setBasketState={_setBasketState}
            formState={formState}
            setFormState={_setFormState}
            setCurrentStepIndex={_setCurrentStepIndex}
            currentStepIndex={currentStepIndex}
            listData={listData}
            setListData={_setListData}
            validateCurrentOptionForm={validateCurrentOptionForm}
            modelLoaded={modelLoaded}
          />
          <Footer
            basketState={basketState}
            setBasketState={_setBasketState}
            formState={formState}
            setFormState={_setFormState}
            setCurrentStepIndex={_setCurrentStepIndex}
            currentStepIndex={currentStepIndex}
            listData={listData}
            setListData={_setListData}
            validateCurrentOptionForm={validateCurrentOptionForm}
          />
        </Container>
      </Div100vh>
    </>
  );
}

export default App;
